<template>
  <div class="query-export">
    <el-button type="primary" @click="handlerBtnClick">
      <slot></slot>
    </el-button>

    <el-dialog title="导出" :visible.sync="isShowQueryExportDialog" width="20%" center>
      <el-form ref="form" :model="exportFormData" label-width="80px">
        <el-form-item label="开始时间">
          <el-date-picker v-model="exportFormData.startTime" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="exportFormData.endTime" type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlerExport">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    initDate: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShowQueryExportDialog: false, // 是否显示查询导出对话框
      // 导出表单数据
      exportFormData: {
        startTime: "", // 开始时间
        endTime: "", // 结束时间
      },
    };
  },
  methods: {
    // 触发按钮单击
    handlerBtnClick(e) {
      this.$emit("click"); // 父级导出按钮单击事件
      let { startTime, endTime } = this.initDate;
      // if (startTime) {
      //   startTime = this.timestampToTime(startTime.getTime());
      // }
      if (startTime || endTime) {
        this.exportFormData.startTime = startTime
        this.exportFormData.endTime = endTime
      } else {
        this.exportFormData.startTime = "";
        this.exportFormData.endTime = "";
      }

      this.isShowQueryExportDialog = true;
    },
    // 触发导出按钮
    handlerExport() {
      if (!this.exportFormData.startTime || !this.exportFormData.endTime) {
        this.$message({
          message: "请选择开始时间和结束时间",
          type: "warning",
        });
        return;
      }
      console.log(this.exportFormData)
      var determineTimeresult = this.determineTime(
        this.exportFormData.startTime,
        this.exportFormData.endTime
      );
      if (!determineTimeresult) {
        this.$message({
          message: "开始时间应小于结束时间并且间隔小于31天",
          type: "warning",
        });
        return;
      }
      this.$emit("export", this.exportFormData); // 父级确定导出按钮单击事件
      this.isShowQueryExportDialog = false;
    },
    determineTime(starTime, endTime) {
      // var data1 = Date.parse(starTime.replace(/-/g, "/"));
      // var data2 = Date.parse(endTime.replace(/-/g, "/"));
      var data1 = new Date(starTime.replace(/-/g, "/")).getTime();
      var data2 = new Date(endTime.replace(/-/g, "/")).getTime();
      var datadiff = data2 - data1;
      var time = 31 * 24 * 60 * 60 * 1000;
      if (starTime.length > 0 && endTime.length > 0) {
        if (datadiff < 0 || datadiff > time) {
          console.log("开始时间应小于结束时间并且间隔小于31天");
          return false;
        } else {
          return true;
        }
      }
    },
    //转换时间成 2019-08-01 09:55:26 格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      let strDate = Y + M + D + h + m + s;
      return strDate;

    }
  },
};
</script>

<style scoped>
.query-export {
  display: inline-block;
  margin-left: 20px;
}
</style>